import React, { useState } from 'react';
import JoditEditor from 'jodit-react';
import { API_URL } from '../../store/slices/adminSlice';

// Use environment variable or fallback to API_URL
const UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL || `${API_URL}article/uploadfile`;
const BASE_URL = process.env.REACT_APP_BASE_URL || API_URL;

interface TextEditorProps {
  value?: string;
  handleModelChange: (content: string) => void;
}

const TextEditor: React.FC<TextEditorProps> = (props) => {
  const [content] = useState<string>('');

  const onBlur = (newContent: string): void => {
    props.handleModelChange(newContent);
  };

  const FILE_UPLOADER = {
    uploader: {
      enableDragAndDropFileToEditor: true,
      url: UPLOAD_URL,
      insertImageAsBase64URI: false,
      imagesExtensions: ['jpg', 'png', 'jpeg', 'gif'],
      filesVariableName: function (t: any) {
        return 'files';
      },
      withCredentials: false,
      isSuccess: function (resp: any) {
        return resp;
      },
      process: function (resp: any) {
        return {
          files: resp.data,
          baseurl: BASE_URL,
          error: '',
          msg: '',
        };
      },
      defaultHandlerSuccess: function (this: any, data: any) {
        this.selection.insertImage(data.files);
        let i;
        const field = 'files';
        if (data[field] && data[field].length) {
          for (i = 0; i < data[field].length; i += 1) {
            if (['jpg', 'png', 'jpeg', 'gif'].includes(data[field][i].split('.').pop()))
              this.selection.insertImage(data.baseurl + data[field][i]);
          }
        }
      },
    },
    readonly: false,
    height: 400,
    minHeight: 200,
  };

  return (
    <div>
      <div className="App" style={{ maxWidth: 'auto', margin: '0 auto' }}>
        <JoditEditor
          value={props.value || content}
          config={FILE_UPLOADER}
          onBlur={onBlur}
        />
      </div>
    </div>
  );
};

export default TextEditor;
